module.exports = __webpack_public_path__ + "img/c04_unittechwithoutnumber_Normal_ua.4d508547.webp";